import React from "react";
import classNames from "classnames";

import { useRouter } from "next/router";

import Bouton, { VARIANT } from "../bouton";

import styles from "./pagination.module.scss";
import BoutonLink from "../boutonLink";

type PropTypes = {
    className?: string;
    count?: number;
    total: number;
    maxBeforeAfter?: number;
};

const Pagination = ({ className = "", count = 24, total, maxBeforeAfter = 2 }: PropTypes) => {
    const router = useRouter();
    const offset = Number(router.query.offset) || 0;

    const correctedOffset = Math.max(0, Math.min(total - (total % count), offset));
    const currentPage = Math.floor(correctedOffset / count + 1);
    const lastPages = Math.ceil(total / count);

    const searchParams = new URLSearchParams(router.query as any);
    searchParams.delete("offset")

    return (
        total >= count && (
            <div
                data-component="Pagination"
                className={classNames(styles.me, { [className]: className })}
            >
                <div className={styles.in}>
                    <BoutonLink
                        borderOnly
                        href={`${router.pathname}?${searchParams}&offset=${(currentPage - 2) * count}`}
                        enabled={currentPage > 1}
                        icon="fleche"
                        shape="carre"
                    />
                    {[...Array(lastPages)].map((_, i) => {
                        const page = i + 1;

                        if (
                            currentPage === page - maxBeforeAfter - 1 ||
                            currentPage === page + maxBeforeAfter + 1
                        ) {
                            return (
                                <Bouton
                                    key={`page_${i}`}
                                    variant={VARIANT.BORDER}
                                    enabled={false}
                                    shape="rond"
                                >
                                    ...
                                </Bouton>
                            );
                        }

                        if (
                            page > currentPage + maxBeforeAfter + 1 ||
                            page < currentPage - maxBeforeAfter - 1
                        ) {
                            return null;
                        }

                        return (
                            <BoutonLink
                                key={`page_${i}`}
                                href={`${router.pathname}?${searchParams}&offset=${(page - 1) * count}`}
                                variant={page === currentPage ? VARIANT.PRIMARY : VARIANT.BORDER}
                                enabled={page !== currentPage}
                            >
                                {page}
                            </BoutonLink>
                        );
                    })}
                    <BoutonLink
                        borderOnly
                        href={`${router.pathname}?${searchParams}&offset=${currentPage * count}`}
                        enabled={currentPage < lastPages}
                        icon="fleche-right"
                        shape="carre"
                    />
                </div>
            </div>
        )
    );
};

export default Pagination;
